export default __webpack_public_path__ + "static/media/ICONS-LOGO.e992a0e0.jpeg";